module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.a32fa1f2.eot";